import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FarmFeature } from '../../../../modules/farm-features/models/farm-feature-dto';

@Component({
  selector: 'kw-asset-card',
  template: `
    <div class="asset-card" (click)="open.emit()">
      <div class="ac-ic" [style.background]="tint" [style.color]="color">{{ initial }}</div>
      <div class="ac-main">
        <h4>{{ asset?.name }}</h4>
        <div class="ac-type">{{ asset?.farmFeatureTypeName }}</div>
        <div class="ac-link" *ngIf="asset?.linkedBlockName">&#9741; {{ asset.linkedBlockName }}</div>
        <div class="ac-read" *ngIf="hasReading">
          <div class="r" *ngIf="asset?.temperature_F != null">
            <div class="n">{{ asset.temperature_F | number:'1.0-1' }}<small>&deg;F</small></div><div class="l">Temp</div>
          </div>
          <div class="r" *ngIf="asset?.humidity != null">
            <div class="n">{{ asset.humidity | number:'1.0-0' }}<small>%</small></div><div class="l">Humidity</div>
          </div>
          <div class="r" *ngIf="pressure != null">
            <div class="n">{{ pressure | number:'1.0-0' }}<small> psi</small></div><div class="l">Pressure</div>
          </div>
        </div>
        <div class="cf" *ngIf="customFields?.length" (click)="$event.stopPropagation()">
          <button type="button" class="cf-toggle" (click)="toggleCf($event)" [attr.aria-expanded]="expanded">
            <span class="caret">{{ expanded ? '&#9662;' : '&#9656;' }}</span>
            <span>Custom fields</span> <span class="cf-n">{{ customFields.length }}</span>
          </button>
          <div class="cf-list" *ngIf="expanded">
            <div class="cf-row" *ngFor="let f of customFields">
              <span class="cf-l">{{ f.label }}</span>
              <span class="cf-v">{{ f.value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .asset-card { background: #fff; border: 1px solid #e4e9ef; border-radius: 12px;
      box-shadow: 0 1px 2px rgba(16,32,55,.04), 0 2px 8px rgba(16,32,55,.05);
      padding: 15px 16px; display: flex; gap: 13px; align-items: flex-start; cursor: pointer;
      transition: transform .12s, box-shadow .12s; }
    .asset-card:hover { transform: translateY(-2px); box-shadow: 0 6px 24px rgba(16,32,55,.12); }
    .ac-ic { width: 42px; height: 42px; border-radius: 10px; flex: none; display: grid; place-items: center; font-size: 16px; font-weight: 700; }
    .ac-main { flex: 1; min-width: 0; }
    .ac-main h4 { margin: 0; font-size: 14.5px; font-weight: 700; }
    .ac-type { font-size: 11.5px; color: #64748b; font-weight: 600; margin-top: 1px; }
    .ac-link { font-size: 11.5px; color: #0884a5; margin-top: 7px; }
    .ac-read { display: flex; gap: 16px; margin-top: 11px; padding-top: 11px; border-top: 1px solid #eef2f6; }
    .ac-read .r .n { font-size: 17px; font-weight: 700; letter-spacing: -.3px; font-variant-numeric: tabular-nums; }
    .ac-read .r .n small { font-size: 11px; color: #94a3b8; font-weight: 600; }
    .ac-read .r .l { font-size: 10px; color: #64748b; font-weight: 600; text-transform: uppercase; letter-spacing: .4px; margin-top: 2px; }
    .cf { margin-top: 10px; padding-top: 4px; border-top: 1px solid #eef2f6; }
    .cf-toggle { border: none; background: none; width: 100%; padding: 9px 4px; cursor: pointer; font-size: 12px; font-weight: 600; color: #253d5b;
      display: flex; align-items: center; gap: 6px; border-radius: 6px; text-align: left; }
    .cf-toggle:hover { background: #f5f7f9; }
    .cf-toggle .caret { font-size: 10px; color: #94a3b8; }
    .cf-toggle .cf-n { font-size: 11px; color: #64748b; background: #eef2f6; border: 1px solid #e4e9ef; border-radius: 999px; padding: 0 7px; margin-left: auto; }
    .cf-list { margin-top: 10px; display: flex; flex-direction: column; gap: 7px; }
    .cf-row { display: flex; justify-content: space-between; gap: 12px; font-size: 12px; }
    .cf-row .cf-l { color: #64748b; font-weight: 600; flex: none; }
    .cf-row .cf-v { color: #17212e; text-align: right; word-break: break-word; }
  `]
})
export class AssetCardComponent {
  @Input() asset: FarmFeature;
  @Input() customFields: { label: string; value: any }[] = [];
  @Output() open = new EventEmitter<void>();

  expanded = false;

  toggleCf(event: Event): void {
    event.stopPropagation();
    this.expanded = !this.expanded;
  }

  get color(): string {
    return this.asset?.farmFeatureTypeIconColor || '#253d5b';
  }

  get tint(): string {
    return (this.asset?.farmFeatureTypeIconColor || '#253d5b') + '1a';
  }

  get initial(): string {
    return (this.asset?.farmFeatureTypeName || this.asset?.name || '?').substring(0, 1).toUpperCase();
  }

  get pressure(): number {
    return this.asset?.pressure_psi != null ? this.asset.pressure_psi : this.asset?.pressure_PSI;
  }

  get hasReading(): boolean {
    return this.asset?.temperature_F != null || this.asset?.humidity != null || this.pressure != null;
  }
}
